<div class="card mb-3" *ngIf="visible">
    <div class="card-header d-flex justify-content-between align-items-center"
        style="cursor: pointer;"
        (click)="expanded = !expanded">
        <strong>Review Date Overrides</strong>
        <span>
            <span *ngIf="overrideCount > 0" class="badge badge-info mr-2">{{ overrideCount }}</span>
            <i class="fa" [class.fa-chevron-down]="!expanded" [class.fa-chevron-up]="expanded"></i>
        </span>
    </div>
    <div class="card-body" *ngIf="expanded">
        <p class="text-muted small mb-2">
            Dates set here apply to this case only and win over the period-wide review dates
            (extensions/exceptions). Clear a date to revert the case to the period-wide value.
            <strong>No change takes effect until you click Save.</strong>
        </p>
        <table class="table table-sm table-bordered mb-2" style="background: white;">
            <thead>
                <tr>
                    <th>Milestone</th>
                    <th style="width: 150px;">Period date</th>
                    <th style="width: 230px;">This case</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows">
                    <td>{{ row.milestone.displayName }}</td>
                    <td>
                        <span *ngIf="row.periodDate; else noPeriodDate">{{ row.periodDate | date:'mediumDate' }}</span>
                        <ng-template #noPeriodDate><span class="text-muted small">—</span></ng-template>
                    </td>
                    <td>
                        <div class="d-flex align-items-center">
                            <input class="form-control form-control-sm"
                                [matDatepicker]="picker"
                                [(ngModel)]="row.override"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="MM/DD/YYYY" />
                            <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker [startAt]="row.periodDate"></mat-datepicker>
                            <button type="button" class="btn btn-sm btn-link text-danger px-1"
                                *ngIf="row.override"
                                title="Clear override"
                                (click)="row.override = null">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <button class="btn btn-sm btn-primary" (click)="save()" [disabled]="saving || hasInvalidDate || !hasUnsavedChanges">
            {{ saving ? 'Saving…' : 'Save overrides' }}
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary ml-2"
            (click)="cancel()" [disabled]="saving || !hasUnsavedChanges">
            Cancel
        </button>
        <span *ngIf="hasUnsavedChanges && !hasInvalidDate" class="text-warning small ml-2">
            <i class="fa fa-exclamation-triangle"></i> Unsaved changes
        </span>
        <span *ngIf="hasInvalidDate" class="text-danger small ml-2">
            Fix invalid dates before saving.
        </span>
    </div>
</div>
